import React, { useEffect, useState } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { Wordmark } from "./Logo";
import { Menu, X, Lock } from "lucide-react";
import { NAV, CONTACT_EMAILS } from "../data/site";

const Header = () => {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const location = useLocation();

    useEffect(() => setOpen(false), [location.pathname]);
    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 4);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="site-header"
            className={`sticky top-0 z-40 transition-colors duration-200 ${
                scrolled
                    ? "bg-white border-b border-[var(--ns-border)]"
                    : "bg-white/95 border-b border-transparent"
            }`}
        >
            <div className="max-w-[1280px] mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
                <Link to="/" data-testid="nav-logo">
                    <Wordmark />
                </Link>

                <nav className="hidden lg:flex items-center gap-9">
                    {NAV.map((n) => (
                        <NavLink
                            key={n.to}
                            to={n.to}
                            end={n.to === "/"}
                            data-testid={`nav-link-${n.label.replace(/\s|&/g, "").toLowerCase()}`}
                            className={({ isActive }) =>
                                `font-body text-[14px] transition-colors ${
                                    isActive
                                        ? "text-[var(--ns-ink)] font-medium"
                                        : "text-[var(--ns-muted)] hover:text-[var(--ns-ink)]"
                                }`
                            }
                        >
                            {n.label}
                        </NavLink>
                    ))}
                </nav>

                <div className="flex items-center gap-3">
                    <Link
                        to="/portal/login"
                        className="ns-btn-ghost hidden md:inline-flex"
                        data-testid="nav-rfq-login"
                    >
                        <Lock size={14} strokeWidth={2} /> RFQ Login
                    </Link>
                    <Link
                        to="/contact"
                        className="ns-btn-primary hidden sm:inline-flex"
                        data-testid="nav-contact-cta"
                    >
                        Contact
                    </Link>
                    <button
                        type="button"
                        aria-label="Toggle menu"
                        onClick={() => setOpen((v) => !v)}
                        className="lg:hidden w-10 h-10 flex items-center justify-center border border-[var(--ns-border)]"
                        data-testid="nav-menu-toggle"
                    >
                        {open ? <X size={18} /> : <Menu size={18} />}
                    </button>
                </div>
            </div>

            {open && (
                <div className="lg:hidden border-t border-[var(--ns-border)] bg-white">
                    <div className="max-w-[1280px] mx-auto px-6 py-4 flex flex-col gap-1">
                        {NAV.map((n) => (
                            <NavLink
                                key={n.to}
                                to={n.to}
                                end={n.to === "/"}
                                className={({ isActive }) =>
                                    `py-3 font-body text-base ${
                                        isActive
                                            ? "text-[var(--ns-ink)] font-medium"
                                            : "text-[var(--ns-muted)]"
                                    }`
                                }
                            >
                                {n.label}
                            </NavLink>
                        ))}
                        <Link
                            to="/contact"
                            className="py-3 font-body text-base text-[var(--ns-ink)] font-medium"
                        >
                            Contact
                        </Link>
                        <Link
                            to="/portal/login"
                            className="py-3 font-body text-base text-[var(--ns-ink)] font-medium inline-flex items-center gap-2"
                            data-testid="mobile-nav-rfq-login"
                        >
                            <Lock size={14} /> RFQ Login
                        </Link>
                        <a
                            href={`mailto:${CONTACT_EMAILS[0]}`}
                            className="py-3 font-body text-sm text-[var(--ns-muted)]"
                        >
                            {CONTACT_EMAILS[0]}
                        </a>
                    </div>
                </div>
            )}
        </header>
    );
};

export default Header;
